import {appConfig} from '@/config/appConfig';
import {debug} from '@/shared/helpers/debug';
import {App} from '@capacitor/app';
import type {Plugin} from 'vue';
import {useRouter} from 'vue-router';

/**
 * Configures handling of hybrid app specific global functionality:
 * - Handling of authentication redirects (MSAL and OIDC)
 *
 * Supported URL formats:
 * - Unified scheme: dev.deskly.app://msauth#code=... or dev.deskly.app://login#code=...
 */
export const hybridAppPlugin = {
    install(app) {
        if (!appConfig.isHybridApp) {
            return;
        }
        app.runWithContext(() => {
            const router = useRouter();

            App.addListener('appUrlOpen', async data => {
                debug.log('App opened with URL:', data.url);

                // Check for unified scheme format: dev.deskly.app://msauth or dev.deskly.app://login
                if (data.url.includes('://msauth')) {
                    return handleMsalAuthenticationRedirect(data.url);
                }

                if (data.url.includes('://login')) {
                    handleOidcAuthenticationRedirect(data.url);
                }
            });

            function handleMsalAuthenticationRedirect(url: string) {
                const code = url.split('#')[1];
                debug.log('Extracted code from URL:', code);

                router.push({name: 'Home', hash: '#' + code});
            }

            function handleOidcAuthenticationRedirect(url: string) {
                const parsedUrl = new URL(url);
                const queryString = parsedUrl.search;

                debug.log('Redirecting to callback with query string:', queryString);

                const resolved = router.resolve({name: 'CallBack'});
                router.push(resolved.path + queryString);
            }
        });
    },
} satisfies Plugin;
